export default {
  otherDocDetail: {
    viewClient: 'VISTA CLIENTE',
    viewStaff: 'VISTA STAFF',
    copyLmdx: 'COPIAR LMDX',
    downloadCropped: 'DESCARGAR RECORTADO',
    runningInfo: 'Información de ejecución:',
    errors: 'Errores:'
  },
  ViesValidator: {
    documents: "Documentos",
    upload_documents: "Subir documentos",
    actions: "ACCIONES",
    add_filter: "Añadir filtro",
    delete_documents: "Eliminar documentos",
    continue_workflow: "Reintentar",
    restart_workflow: "Reiniciar",
    refresh: "Actualizar",
    download_documets: "Descargar documentos",
    download: "Descargar",
    change_workflow: "Cambiar Workflow",
    relaunch_workflow: "Relanzar Workflow",
    move_to_a_folder: "Mover a una carpeta",

    // popup eliminar docs
    warning_delete: "Se eliminarán los documentos seleccionados. ",
    warning_delete_2: "¿Está seguro?",
    checkbox_text: "Eliminar registros asociados",
    cancel: "Cancelar",
    delete: "Eliminar",

    modify_workflow: "Modificar workflow",
    change: "Cambiar",
    
    select_folder_tooltip: "Seleccionar carpeta",
    select_folder: "Selecciona la carpeta destino",
    create_folder: "Crear carpeta",
    hide_my_unit: "Ocultar Mi unidad",
    create: "Crear",
    accept: "Aceptar",
    folder_name: "Nombre de la carpeta",
    privacy_label: "Marcar como privada",

    delete_folder: "Borrar carpeta",
    warning_delete_folder: "¿Está seguro de que desea borrar la carpeta seleccionada?",
    delete_folder_only: "Borrar solo la carpeta (mantener el contenido)",
    delete_folder_recursively: "Borrar carpeta y todo su contenido",
    delete: "Borrar",

    edit_folder: "Editar carpeta",
    name_folder: "Nombre de la carpeta",
    edit: "Editar",

    select_folder: "Selecciona la carpeta destino",

    id: "Id",
    document_name: "Nombre del documento",
    document_type: "Tipo de documento",
    upload_data: "Fecha de subida",
    workflow: "Workflow",
    state: "Estado",
    folder_path: "Ruta",
    search_all_documents: "Buscar en todos los documentos...",
    search_results_global: "Resultados de \"{term}\" en todas las carpetas ({count} documentos)",

    payroll: "Nómina",
    contract: "Contrato",
    model_tax: "Modelos/Impuestos",
    certificate: "Certificado",
    bill: "Factura",
    other: "Otros",
    pending: "Pendiente",
    waiting_approval: "Pendiente de aprobación",
    waiting: "En espera",
    approved: "Aprobado",
    rejected: "Rechazado",
    insufficient_credits: "Saldo insuficiente",
    lost_workflow: "Error workflow desaparecido",
    no_workflow: "Sin workflow",
    error: "Error",
    done: "Completado",
    WaitForApproval: "Esperar aprobación",
    AskAI: "Extracción de informacion con IA",
    AddDocumentRepresentationToConversation: "Añadir representación de documento a conversación",
    CompleteConversation: "Completar conversación con IA",
    UploadAsInvoice: "Subir como factura",
    SendThroughEmail: "Enviar por correo electrónico",
    SendEmailWithTemplate: "Enviar correo electrónico con plantilla",
    LookupAndMatchInstance: "Buscar y adjuntar registro",
    LookupAndMatchMultipleInstances: "Buscar y adjuntar varios registros",
    ExtractInstanceFromRawData: "Extraer registro previamente inyectado",
    CreateInstanceFromContext: "Crear registro a partir de contexto",
    CreateInstance: "Crear registro",
    CreateInstancesFromList: "Crear registros a partir de lista",
    AddInstanceToList: "Añadir registro a lista",
    ModifyContext: "Modificar registro",
    DeleteContextInstance: "Eliminar registro",
    PayrollAccounting: "Contabilizar nómina",
    SendDataToEndpoint: "Enviar datos a un endpoint",
    NotifyCounterpart: "Notificar a la contraparte",
    RunCommand: "Ejecutar comando",
    RunQuery: "Ejecutar consulta",
    RunWorkflow: "Ejecutar workflow",
    RunScript: "Ejecutar script de python",
    SplitFile: "Separar páginas de archivo",
    ExtractTextFromDocument: "Extraer texto del documento",

    docs_per_page: "Documentos por página",
    of: "de",

    "not_same_wf":"Todos los documentos seleccionados deben tener el mismo workflow",

    my_unit: "Mi unidad",
    new: "Nuevo",

    label_name: "Nombre",
    label_type: "Tipo",
    label_date_from: "Fecha desde",
    label_date_to: "Fecha hasta",
    label_pending_my_approval: "Pendiente de mi aprovación",

    //mobile
    filters: "Filtros",
    type_of_document: "Tipo de doc",
    date: "Fecha",
  },
  AddFilterDocuments: {
    add_filter: "Añadir filtro",
    see_invoices: "Ver facturas",
  },
  PDFDocumentV2: {
    invoice_detail: "Detalle de la factura",
    doc_detail: "Detalle del documento",
    upload_invoice: "Subir factura",
  },
  GeneralWorkflowDetail: {
    continue_workflow: "Reintentar",
  },
  AppSearchAddFilterBtn: {
    add_filter: 'Añadir filtro',
    delete_filters: 'Borrar filtros',
    state: 'Estado',
    pending: "Pendiente",
    waiting_approval: "Pendiente de aprobación",
    approved: "Aprobado",
    rejected: "Rechazado",
    insufficient_credits: "Saldo insuficiente",
    lost_workflow: "Error workflow desaparecido",
    error: "Error",
    done: "Completado",
    WaitForApproval: "Esperar aprobación",
    filter: "Filtro",
  },
  AppSearchFilterChip: {
    value: "Valor",
    payroll: "Nómina",
    contract: "Contrato",
    taxes_and_models: "Modelos/Impuestos",
    certificate: "Certificado",
    invoices: "Facturas",
    others: "Otros",
    all: "Todos",
    yes: "Sí",
    no: "No",
    no_options_available: "No hay opciones disponibles",
  },
  OtherDocWorkflowDetail: {
    staff_view: 'VISTA STAFF',
    client_view: 'VISTA CLIENTE',

    copy_lmdx: 'COPIAR LMDX',
    download_cropped: 'DESCARGAR RECORTADO',
  },
  CommentSectionComponent: {
    no_comments: "No hay comentarios",
    write_your_comment: "Escribe tu comentario....",
  },
  ExtractedDataComponent: {
    extracted_information: "Información extraída",
  },
  GenericDocumentLoader: {
    upload_documents: "Subir documentos",
    title_upload_docs: "Desde aquí puedes subir todos tus documentos",
    subtitle: "Puede ser en formato pdf/jpg/png",
    drag_files: "Arrastre aquí sus ficheros o haga click para seleccionar ficheros desde carpeta",
    document_type: "Tipo de documento",
    invoice_type: "Tipo de factura",

    add_type: "Añadir tipo",
    edit_workflows: "Editar workflows",

    my_unit: "Mi unidad",
    select_location: "Seleccionar ubicación",
    select_folder: "Selecciona la carpeta destino",
    cancel: "Cancelar",
    accept: "Aceptar",

    payroll: "Nómina",
    contract: "Contrato",
    taxes_and_models: "Modelos/Impuestos",
    certificate: "Certificado",
    invoices: "Facturas",
    others: "Otros",
    add_type: "Añadir tipo",

    out_invoice: 'Factura de cliente',
    in_invoice: 'Factura de proveedor',

    types_of_documents: "Tipos de documentos",
    name: "Nombre",
    close: "Cerrar",
    save: "Guardar",

    no_workflow: "Sin workflow",

    //mobile
    drag_files_mobile: "Arrastre aquí sus documentos",
  },
  WorkflowList: {
    refresh: "Actualizar",
  },
  SelectorEmpresa: {
    company: "Empresa",
  },
  App: {
    invoices: "Contabilidad",
    suppliers: "Proveedores",
    customers: "Clientes",
    banks: "Bancos",
    electronic_invoice: "Factura Electrónica",
    gestor_ia: "Gestor IA",
    invoice_approval: "Aprobación de facturas",
    documents: "Documentos",
    my_records: "Mis Registros",
    remesas: "Remesas",
    payrolls: "Nóminas",
    dashboard: "Panel de Control",
    clock_in: "Control Horario",
    tickets: "Tickets",
    persons: "Personas",
    settings: "Ajustes",
    trash: "Papelera",

    my_companies: "Mis Empresas",
    manager_summary: "Cuadro Resumen Gestor",
    accounting_summary: "Cuadro Resumen Contabilidad",
    configuration: "Configuración",
    my_data: "Mis Datos",
    my_expenses: "Mis Gastos",
    guidelines: "Guidelines",
    functionalities: "Funcionalidades",
    kpis: "KPIs",
    access_log: "Registro de Acceso",
    backup_log: "Registro de Backups",
    network_drives: "Unidades De Red",
    whats_new: "Novedades",
    log_out: "Cerrar Sesión",
    tariffs_management: "Gestión de tarifas",
    client_tariff: "Tarifa del cliente",
    users: "Usuarios",
    locations: "Ubicaciones",
    download_client: "Descargar Cliente",
    onboard_info: "Información Onboard",
    reports: "Informes",
    bank_summary: "Cuadro Resumen Bancos",
    contracts_kpis: "Contratos KPIs",
    supplier_prompts_ai: "Prompts para Terceros IA"
  },
  UserConfiguration: {
    header: "Configuración del usuario",
    title1: "Configura tu usuario para aprovechar Inmatic al máximo",
    title2: "Configura tu usuario para aprovechar el programa al máximo",
    body: "Aquí podrás encontrar las opciones autogestionables para que logres configurar tu usuario."
  },
  ListObject: {
    companies: "Empresas",
    configuring: "Configurando...",
    per_page: "por página",
    of: "de",

    id: "Id",
    company_name: "Nombre de empresa",
    company_cif: "CIF Empresa",
    route: "Ruta",
    state: "Estado",
    type: "Tipo",
  },
  ConnectorList:{
    companies: "Empresas",
  },
  PopupCreateCompany: {
    create_companies: "Crear una Empresa",
    edit_company: "Editar Empresa",
    company_name: "Nombre de la empresa",
    company_cif: "Cif de la empresa",
    cancel: "Cancelar",
    edit: "Editar",
    create: "Crear",
    save: "Guardar",
  },
  ItemFilterDocuments: {
    name: "Nombre",
    type: "Tipo",
    date_from: "Fecha desde",
    date_to: "Fecha hasta",
    pending_my_approval: "Pendiente de mi aprobación",

    payroll: "Nómina",
    contract: "Contrato",
    taxes_and_models: "Modelos/Impuestos",
    certificate: "Certificado",
    invoices: "Facturas",
    others: "Otros",
    all: "Todos",

    yes: "Sí",
    no: "No",
  },
  Connector2List: {
    create_company: "Crear empresa",
    refresh: "Refrescar",
    companies: "Empresas",
    id: "Id",
    name: "Nombre",
    cif: "CIF"
  },
  narcisTest:{
    'title': 'Prueba de Narci',
  }
}
